import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gestao-de-risco',
  templateUrl: './gestao-de-risco.component.html',
  styleUrls: ['./gestao-de-risco.component.css']
})
export class GestaoDeRiscoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
